import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { clampPercent } from './summary-ui';

@Component({
  standalone: false,
  selector: 'summary-gauge',
  templateUrl: './summary-gauge.component.html',
  styleUrls: ['./summary-gauge.component.scss']
})
export class SummaryGaugeComponent implements OnChanges, OnDestroy {
  @Input() percent = 0;
  @Input() display = '0%';
  @Input() statusLabel = 'Not Started';
  @Input() badgeClass = 'is-neutral';
  @Input() gaugeColor = '#d1d5db';
  @Input() isActive = true;
  @Input() playToken = 0;
  animatedPercent = 0;
  private playTimer: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['percent'] || changes['isActive'] || changes['playToken']) {
      this.play();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  get dashArray(): string {
    return `${clampPercent(this.animatedPercent)} 100`;
  }

  private play() {
    this.clearTimer();
    this.animatedPercent = 0;
    if (!this.isActive) {
      return;
    }
    this.playTimer = setTimeout(() => {
      this.animatedPercent = this.percent || 0;
    }, 40);
  }

  private clearTimer() {
    if (this.playTimer) {
      clearTimeout(this.playTimer);
      this.playTimer = null;
    }
  }
}
